//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useDispatch, useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import CommonTitle from "../../../components/common/common.title";
import CommonProduct from "../../../components/common/common.product";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect } from "react";
import { getProductList } from "../../../redux/reducer/product.reducer";

export default function HomeProduct() {
  const dispatch = useDispatch();
  const { width } = useWindowDimension();
  const { productList, productListLoading } = useSelector(
    (state) => state.product
  );

  let displayProduct = 10;
  let skeletonProduct = 5;

  if (width < 1150) {
    displayProduct = 6;
    skeletonProduct = 3;
  } else if (width < 1440) {
    displayProduct = 8;
    skeletonProduct = 4;
  }

  useEffect(() => {
    dispatch(getProductList());
  }, []);

  return (
    <Container className="home-product">
      <CommonTitle title="New Arrival" subtitle="Explore Our" shopAll />
      {width < 870 ? (
        <Swiper
          grabCursor={true}
          slidesPerView="auto"
          spaceBetween={width < 450 ? 25 : 30}
          className="_row product-list"
        >
          {productListLoading
            ? Array.from(
                { length: skeletonProduct },
                (_, productLoadingIndex) => (
                  <SwiperSlide className="col-center gap-4 pointer">
                    <CommonProduct loading key={productLoadingIndex} />
                  </SwiperSlide>
                )
              )
            : productList?.length > 0 &&
              productList
                .slice(0, displayProduct)
                .map((product, productIndex) => (
                  <SwiperSlide>
                    <CommonProduct
                      product={product}
                      key={productIndex}
                      className="--home"
                    />
                  </SwiperSlide>
                ))}
        </Swiper>
      ) : (
        <Row className="_row product-list">
          {productListLoading
            ? Array.from(
                { length: skeletonProduct },
                (_, productLoadingIndex) => (
                  <CommonProduct loading key={productLoadingIndex} />
                )
              )
            : productList?.length > 0 &&
              productList
                .slice(0, displayProduct)
                .map((product, productIndex) => (
                  <CommonProduct
                    product={product}
                    key={productIndex}
                    className="--home"
                  />
                ))}
        </Row>
      )}
    </Container>
  );
}
